import BigNumber from 'bignumber.js/bignumber';
import { isDev } from 'config/config';

import EGLD from 'assets/img/coins/egld.svg';
import UNKNOWN from 'assets/img/coins/unknown.png';
import { coinNames } from './constant';

export const getSymbol = (tokenIdentifier: string): string => {
    const tokenSymbol = tokenIdentifier.split('-')[0].toUpperCase();

    return tokenSymbol;
};

export const shortenAddress = (address: string): string => {
    const shortened = address.substring(0, 6) + '...' + address.substring(address.length-6);

    return shortened;
};

export const convertWeiToEsdt = (v: any, decimals = 18): BigNumber => {
    let value;

    if (typeof (v) !== typeof (BigNumber)) {
        value = new BigNumber(v);
    } else {
        value = v;
    }

    const result = value.dividedBy(new BigNumber(10 ** decimals));

    return result;
};

export const convertEsdtToWei = (v: any, decimals = 18): BigNumber => {
    let value;

    if (typeof (v) !== typeof (BigNumber)) {
        value = new BigNumber(v);
    } else {
        value = v;
    }

    const result = value.multipliedBy(new BigNumber(10 ** decimals)).decimalPlaces(0, BigNumber.ROUND_FLOOR);

    return result;
};

export const shortenEsdt = (v: any, precision = 4): string => {
    let value;

    if (typeof (v) !== typeof (BigNumber)) {
        value = new BigNumber(v);
    } else {
        value = v;
    }

    const number = +value.toFixed(precision, BigNumber.ROUND_FLOOR);

    // console.log(number);

    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: precision }).format(number);

    // const result = value.toFixed(precision, BigNumber.ROUND_FLOOR).replace(/^0+(?!\.)|(?:\.|(\..*?))0+$/gm, '$1');
    // return result;
};

export const paddingTwoDigits = (num: any) => {
    return num.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    });
};

export const UnwrapToken = (token_id: string) => {
    if(token_id == coinNames[1]) {
        return 'EGLD';
    } else {
        return token_id;
    }
};

export const getTokenImg = (token_id: string) => {
    if(token_id == 'EGLD') {
        return EGLD;
    } else {
        return isDev ? 
            `https://raw.githubusercontent.com/ElrondNetwork/assets/master/devnet/tokens/${token_id}/logo.png` :
            `https://raw.githubusercontent.com/ElrondNetwork/assets/master/tokens/${token_id}/logo.png`;
    }
};

export const handleTokenImgError = (e: any) => {
    e.target.src = UNKNOWN;
};